/** GPS Plot Map Action Types */
export const GET_GPS_PLOT_DATA = "GET_GPS_PLOT_DATA";
export const GPS_PLOT_API_SUCCESS = "GPS_PLOT_API_SUCCESS";
export const GPS_PLOT_API_FAIL = "GPS_PLOT_API_FAIL";
